import React, { useState, useMemo, useEffect } from "react"
import { Row, Col, Card, Table, Modal, Label, Form } from "reactstrap"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
// assets
import Loader from "pages/Separate/Loader"
import NewPagination from "components/Common/Newpagination"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import leaveImg2 from "../../../assets/images/LeaveDetails.jpg"
import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData"
import Swal from "sweetalert2"
import { customGlobalFilter } from "utils/common-helpers"
import {
  leaveColumns,
  seoReportColumns,
} from "utils/columns/ElementsColumns/searchColumns"
import { ResizableBox } from "react-resizable"
import Draggable from "react-draggable"
import moment from "moment"
import secureLocalStorage from "react-secure-storage"

function TableContainer({ columns, data }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      globalFilter: customGlobalFilter,
      initialState: {
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  )
  const { pageIndex, pageSize, globalFilter } = state

  useEffect(() => {
    setPageSize(10)
  }, [])
  // Render the UI for your table

  return (
    <div>
      <Row>
        <Col xl="12">
          <div className="card-body ">
            <div className="d-flex justify-content-between mb-2">
              <div className="mb-3 text-purple fs-5  fw-bold">
                SEO Report Approval
              </div>
            </div>
            <Row className="mb-2 justify-content-between">
              <div className="mb-3 mb-md-0 d-flex justify-space-between align-items-center">
                <div className="col-1 me-md-5">
                  <select
                    className="border-radius form-select"
                    style={{ width: "100px" }}
                    value={pageSize}
                    onChange={e => setPageSize(e.target.value)}
                  >
                    {[10, 25, 50, 100].map(pageSize => (
                      <option key={pageSize} value={pageSize}>
                        Show {pageSize}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-10 d-flex justify-content-end align-items-center">
                  <div className="col-4 cusrtom_search_box">
                    <div className="search-box me-xxl-2 my-xxl-0 d-inline-block w-100">
                      <div className="">
                        <div className="position-relative">
                          <label
                            htmlFor="search-bar-0"
                            className="search-label w-100 mb-0"
                          >
                            <span id="search-bar-0-label" className="sr-only">
                              Search this table
                            </span>
                            <input
                              onChange={e => setGlobalFilter(e.target.value)}
                              id="search-bar-0"
                              type="text"
                              className="border-radius form-control rounded h-100 w-100"
                              placeholder={`Search...`}
                              value={globalFilter || ""}
                            />
                          </label>
                          <i className="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Row>
            <div className="position-relative table-responsive">
              <Table className="table table-bordered mt-4" {...getTableProps()}>
                <thead className={`fixed_view_payment_table`}>
                  {headerGroups.map((headerGroup, i) => (
                    <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column, index) => (
                        <th
                          key={index}
                          className={`t-col-${index + 1} ${column.className}`}
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                        >
                          <div className="d-flex align-items-center">
                            <span className="flex-grow-1  header-text">
                              {column.render("Header")}
                            </span>
                            {column.isShortIcon && (
                              <span
                                onClick={() =>
                                  column.getSortByToggleProps().onClick()
                                }
                                className="d-flex align-items-center ms-2"
                              >
                                <i
                                  title="Ascending"
                                  className={`bi bi-arrow-up info-icon ${
                                    column.isSorted && !column.isSortedDesc
                                      ? "text-dark"
                                      : ""
                                  }`}
                                ></i>
                                <i
                                  title="Descending"
                                  className={`bi bi-arrow-down info-icon ${
                                    column.isSorted && column.isSortedDesc
                                      ? "text-dark"
                                      : ""
                                  }`}
                                ></i>
                              </span>
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody
                  className="fix-introducer-header"
                  {...getTableBodyProps()}
                >
                  {page.map((row, i) => {
                    prepareRow(row)
                    const rowBackgroundColor =
                      row?.original?.leave_type == 2
                        ? "bg-light-red2"
                        : "bg-light-blue2"

                    return (
                      <tr
                        className={`row-hover ${rowBackgroundColor}`}
                        {...row.getRowProps()}
                        key={i}
                      >
                        {row.cells.map((cell, index) => {
                          return (
                            <td
                              key={index}
                              className={`t-col-${index + 1} ${
                                cell.column.className
                              }`}
                              {...cell.getCellProps()}
                            >
                              {cell.render("Cell")}
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>

            <Row className="justify-content-md-end justify-content-center align-items-center">
              <NewPagination
                gotoPage={gotoPage}
                canPreviousPage={canPreviousPage}
                previousPage={previousPage}
                canNextPage={canNextPage}
                pageIndex={pageIndex}
                pageOptions={pageOptions}
                pageSize={pageSize}
                page={page}
                data={data}
                nextPage={nextPage}
              />
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  )
}

const SeoReportApproval = () => {
  const [isLoading, setLoading] = useState(false)
  const [modal_Access, setAccessDenied] = useState(false)
  const [data, setData] = useState([])
  const [changesData, setChangesData] = useState([])
  const [changesModal, setChangesModal] = useState(false)
  const toggleLoading = loading => {
    setLoading(loading)
  }

  const onViewChanges = reportData => {
    console.log("reportData: ", reportData)
    setChangesData(reportData)
    setChangesModal(true)
  }

  const onStatusChange = async (reportId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to change the status of this report!",
      icon: "warning",
      showCancelButton: true,
    }).then(async result => {
      if (result.isConfirmed) {
        const res = await fetchNodeData(
          toggleLoading,
          `seoReport/approvePublishReport/${reportId}/${status}`,
          secureLocalStorage.getItem("token")
        )
        if (res?.success || res?.data?.success) {
          Swal.fire("Updated!", "Report status has been updated.", "success")
          fetchReports()
        }
      }
    })
  }

  const column1 = useMemo(
    () => seoReportColumns(onViewChanges, onStatusChange),
    []
  )

  const fetchReports = async () => {
    const res = await fetchNodeData(
      toggleLoading,
      `seoReport/getPublisherReport`,
      secureLocalStorage.getItem("token")
    )
    if (res?.success || res?.data?.success) {
      setData(res?.data)
    }
  }
  useEffect(() => {
    fetchReports()
  }, [])

  const stripHtml = (html = "") => html.replace(/<[^>]*>/g, "").trim()

  const parseHighlights = val =>
    Array.isArray(val) ? val : JSON.parse(val || "[]")

  return (
    <div>
      <React.Fragment>
        {isLoading && <Loader />}
        <div className="">
          <div className="position-relative">
            <Row>
              <Col lg="12">
                <Card>
                  <div className="responsive-table">
                    <TableContainer
                      data={data}
                      toggleLoading={toggleLoading}
                      columns={column1}
                    />
                  </div>
                </Card>
              </Col>
            </Row>
          </div>
        </div>

        <Modal
          isOpen={changesModal}
          size="xl"
          className="modal-fullscreen"
          centered
        >
          <div className="modal-header pe-4">
            <div className="d-flex gap-3 col-md-9 justify-content-between">
              <h5 className="modal-title mt-0">Changes</h5>
            </div>
            <button
              type="button"
              onClick={() => {
                setChangesModal(false)
              }}
              className="btn-modal-close"
            >
              <span aria-hidden="true" className="btn-modal-span">
                &times;
              </span>
            </button>
          </div>

          <div className="modal-body pe-4 pt-0">
            {/* Sticky column labels */}
            <Row
              className="mb-2 py-1 border-bottom bg-white"
              style={{ position: "sticky", top: 0, zIndex: 10 }}
            >
              <Col md="6" className="text-center fw-bold text-success px-0">
                Original (Published)
              </Col>
              <Col md="6" className="text-center fw-bold text-danger px-0">
                Changed (Draft)
              </Col>
            </Row>

            {[
              { key: "report_summary", label: "Report Summary" },
              { key: "challenges", label: "Challenges" },
              {
                key: "keyword_position_summary",
                label: "Keyword Position Summary",
              },
              { key: "next_steps", label: "Next Steps" },
              { key: "highlights", label: "Highlights" },
            ].map(({ key, label }) => {
              const oldVal = changesData?.published_report?.[key]
              const newVal = changesData?.[key]

              const isChanged =
                key === "highlights"
                  ? JSON.stringify(parseHighlights(oldVal)) !==
                    JSON.stringify(parseHighlights(newVal))
                  : stripHtml(oldVal) !== stripHtml(newVal)

              return (
                <Row key={key} className="mb-4">
                  <Col md="12">
                    <h6 className="fw-bold mb-2">{label}</h6>
                  </Col>

                  {/* Original */}
                  <Col md="6">
                    <div
                      className={`p-3 rounded border ${
                        isChanged
                          ? "border-success"
                          : "border-secondary-subtle"
                      }`}
                    >
                      {key === "highlights" ? (
                        <ul className="mb-0">
                          {parseHighlights(oldVal).map((i, idx) => (
                            <li key={idx}>{i}</li>
                          ))}
                        </ul>
                      ) : (
                        <div
                          dangerouslySetInnerHTML={{ __html: oldVal || "-" }}
                        />
                      )}
                    </div>
                  </Col>

                  {/* Changed */}
                  <Col md="6">
                    <div
                      className={`p-3 rounded border ${
                        isChanged
                          ? "border-danger bg-warning-subtle"
                          : "border-secondary-subtle"
                      }`}
                    >
                      {key === "highlights" ? (
                        <ul className="mb-0">
                          {parseHighlights(newVal).map((i, idx) => (
                            <li key={idx}>{i}</li>
                          ))}
                        </ul>
                      ) : (
                        <div
                          dangerouslySetInnerHTML={{ __html: newVal || "-" }}
                        />
                      )}
                    </div>
                  </Col>
                </Row>
              )
            })}
          </div>
        </Modal>

        <AccessDeniedPopup
          modal_Access={modal_Access}
          setAccessDenied={setAccessDenied}
        />
      </React.Fragment>
    </div>
  )
}

export default SeoReportApproval
